






































import { defineComponent } from "vue";
import { mapActions, mapMutations, mapState } from "vuex";
// Components
import RefundCardOption from "@/components/Organisms/RefundNew/RefundCardOption.vue";
import checkBiometryRules from "@/components/Organisms/Biometry/checkRule.js";

const options = [
  {
    id: 1,
    label: "Solicitar novo reembolso",
    description: "Solicite um novo reembolso",
    icon: "plus-circle",
    route: "refund.new.create",
    disabled: false,
    newFunction: false
  },
  {
    id: 2,
    label: "Consultar reembolsos",
    description: "Acompanhe os reembolsos que você solicitou",
    icon: "circle-dollar",
    route: "refund.new.list",
    disabled: false,
    newFunction: false
  },
  {
    id: 3,
    label: "Extrato de reembolso",
    description: "Faça o download do extrato dos seus reembolsos",
    icon: "file-invoice-dollar",
    route: "refund.new.statement",
    disabled: false,
    newFunction: true
  }
];
export default defineComponent({
  name: "RefundOptions",
  components: {
    RefundCardOption
  },
  mixins: [checkBiometryRules],
  data() {
    return {
      options: options
    };
  },
  computed: {
    ...mapState("refund", ["addPermission"]),
    ...mapState("saude", ["profile"]),
    hasPendencies() {
      const avisoPendencias = this.profile.messages.find(message => message.TipoAviso === 2);
      return avisoPendencias;
    }
  },
  methods: {
    ...mapMutations("refund", ["SET_NEW_REFUND"]),
    ...mapActions("refund", ["fetchAddPermission", "getDontShowReceiptDeliveryNoticeAgain", "getIsRefundOdontologico"]),
    navigateTo(route) {
      if (route) {
        if (route === "refund.new.create") {
          this.createNewRefund();
          return;
        }
        this.$router.push({ name: route });
      }
    },
    async createNewRefund() {
      this.$root.$emit("show-loading");
      let path = "";
      if (await this.getDontShowReceiptDeliveryNoticeAgain()) {
        if (await this.getIsRefundOdontologico()) {
          this.SET_NEW_REFUND({ type: false });
          path = "/refund-new/create/terms";
        } else {
          path = "/refund-new/create";
        }
      } else {
        path = "/refund-new/aviso-entrega-recibos-reembolso";
      }
      this.$root.$emit("hide-loading");
      this.validateActiveBiometry({
        service: "/refund/form",
        rules: [],
        type: "",
        routeBack: "/refund-new",
        sucessCallBack: _ => this.$router.push(path)
      });
    },
    toPendency() {
      this.$router.push({ name: "refund.new.list", params: { status: "P" } });
    }
  },
  created() {
    const { type } = this.$route.params;
    if (type && type === "P") {
      this.toPendency();
    }
  },
  async mounted() {
    try {
      await this.$root.$emit("show-loading");
      await this.fetchAddPermission();
    } finally {
      await this.$root.$emit("hide-loading");
    }
    // Desabilita o botão de solicitar novo reembolso caso não tenha permissão
    this.options.find(option => option.route === "refund.new.create").disabled = !this.addPermission;
  }
});
